import {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import API from "../../services/api";

function EditCategory() {

  const { id } =
    useParams();

  const navigate =
    useNavigate();

  const [form,
    setForm] =
    useState({
      name: "",
      status: "active"
    });

  useEffect(() => {
    loadCategory();
  }, []);

  const loadCategory =
    async () => {

      const token =
        localStorage.getItem(
          "adminToken"
        );

      const res =
        await API.get(
          `/categories/${id}`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      setForm(res.data);

    };

  const submit =
    async (e) => {

      e.preventDefault();

      const token =
        localStorage.getItem(
          "adminToken"
        );

      await API.put(
        `/categories/${id}`,
        form,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      navigate(
        "/admin/categories"
      );

    };

  return (
    <div>

      <h1
        className="
        text-3xl
        font-bold
        mb-6
      "
      >
        Edit Category
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        p-6
        rounded-2xl
        max-w-xl
      "
      >

        <input
          value={form.name}
          onChange={(e) =>
            setForm({
              ...form,
              name:
                e.target.value
            })
          }
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          mb-4
        "
        />

        <select
          value={form.status}
          onChange={(e) =>
            setForm({
              ...form,
              status:
                e.target.value
            })
          }
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          mb-4
        "
        >
          <option value="active">
            Active
          </option>

          <option value="inactive">
            Inactive
          </option>

        </select>

        <button
          className="
          px-5
          py-3
          bg-yellow-500
          text-black
          rounded-xl
          font-semibold
        "
        >
          Update Category
        </button>

      </form>

    </div>
  );
}

export default EditCategory;